<template>
  <div>
    <label v-if="label" class="block text-xs font-medium mb-1 text-growth-600">{{ label }}</label>
    <select
      :value="modelValue"
      @change="$emit('update:modelValue', $event.target.value)"
      class="border border-growth-50 rounded px-2 py-1.5 text-sm bg-white focus:ring-2 focus:ring-growth-tangerine focus:border-growth-tangerine transition-all cursor-pointer hover:border-growth-600"
    >
      <option value="">{{ placeholder }}</option>
      <template v-for="opt in options" :key="opt.value">
        <option v-if="opt.divider" disabled>───────</option>
        <option :value="opt.value">{{ opt.label }}</option>
      </template>
    </select>
  </div>
</template>

<script>
export default {
  name: 'FilterSelect',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Select...',
    },
    options: {
      type: Array,
      required: true,
      // [{ value: string, label: string, divider?: boolean }]
    },
  },
  emits: ['update:modelValue'],
}
</script>
